import React from 'react'
import { useTranslation } from 'react-i18next'

import { ICollection } from 'meta/pages/collection'

import Head from 'components/common/Head'

interface Props {
  details: ICollection
}

const CollectionHead: React.FC<Props> = (props) => {
  const { details } = props

  const { t } = useTranslation()

  const title = String(
    t(`collection:head_og_title${details.typeTicketCollections ? '_season' : ''}`, { name: details.name })
  )

  const description = String(
    t(`collection:head_og_description${details.typeTicketCollections ? '_season' : ''}`, { name: details.name })
  )

  return (
    <Head>
      <title>{title}</title>

      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${window.location.href}`} />
      <meta property="og:image" content={details.coverImages[0].url} />
      <meta property="og:site_name" content="TicketSms.it" />
      <meta property="og:locale" content="it_IT" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@TicketSms.it" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={details.coverImages[0].url} />
      <meta name="twitter:creator" content="@TicketSms" />
    </Head>
  )
}

export default CollectionHead
